import { SVGProps } from 'react';

const AdminGuidedTourBannerDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="uuid-f8a6c072-40dc-446a-bce9-f61fd6511921"
    data-name="Hybrid Cloud 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1080 1080"
    width="100%"
    {...props}
  >
    <defs>
      <style>
        {
          '.uuid-32b43f5e-f0d1-49a5-ab2e-288b1dca8a9e,.uuid-66d1e3de-ea26-4b90-aca4-6733c42c8b1a,.uuid-91dc50e0-ae24-409e-81f3-9b32b5558ae9,.uuid-a5d948ef-0976-4021-8af2-c95112228428,.uuid-c0fc4a04-49b4-41b6-9274-b2a3abceeadf,.uuid-c8385442-ac2c-47fb-855e-85c4f2d77532,.uuid-dd96de9e-052f-408c-b767-af3056f5d898,.uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088{fill:none}.uuid-32b43f5e-f0d1-49a5-ab2e-288b1dca8a9e,.uuid-66d1e3de-ea26-4b90-aca4-6733c42c8b1a,.uuid-91dc50e0-ae24-409e-81f3-9b32b5558ae9,.uuid-a5d948ef-0976-4021-8af2-c95112228428,.uuid-c0fc4a04-49b4-41b6-9274-b2a3abceeadf,.uuid-dd96de9e-052f-408c-b767-af3056f5d898{stroke-linecap:round}.uuid-32b43f5e-f0d1-49a5-ab2e-288b1dca8a9e,.uuid-66d1e3de-ea26-4b90-aca4-6733c42c8b1a,.uuid-91dc50e0-ae24-409e-81f3-9b32b5558ae9,.uuid-96593b59-46bf-4b64-bafb-a0122c6e07a4,.uuid-a5d948ef-0976-4021-8af2-c95112228428,.uuid-c0fc4a04-49b4-41b6-9274-b2a3abceeadf,.uuid-dd96de9e-052f-408c-b767-af3056f5d898{stroke-miterlimit:10}.uuid-a5d948ef-0976-4021-8af2-c95112228428,.uuid-dd96de9e-052f-408c-b767-af3056f5d898{stroke:#fff}.uuid-96593b59-46bf-4b64-bafb-a0122c6e07a4,.uuid-a5d948ef-0976-4021-8af2-c95112228428{stroke-width:3px}.uuid-32b43f5e-f0d1-49a5-ab2e-288b1dca8a9e,.uuid-66d1e3de-ea26-4b90-aca4-6733c42c8b1a,.uuid-c8385442-ac2c-47fb-855e-85c4f2d77532{stroke:#000}.uuid-32b43f5e-f0d1-49a5-ab2e-288b1dca8a9e,.uuid-c0fc4a04-49b4-41b6-9274-b2a3abceeadf,.uuid-c8385442-ac2c-47fb-855e-85c4f2d77532{stroke-width:2.16px}.uuid-c8385442-ac2c-47fb-855e-85c4f2d77532{stroke-linejoin:round}.uuid-232b251e-1b1e-4d37-a9c6-9d684d739f11,.uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a,.uuid-4617f224-e900-44d3-8a42-c09527ea44f0,.uuid-5b157734-be81-4971-ae0a-27c9963600e9,.uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5,.uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1,.uuid-9e23771d-c576-4522-a585-490ce74a0064,.uuid-a3281ad5-a5c9-4204-a2f1-c4e6a296561a,.uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0,.uuid-bd97af27-f0f6-4711-9267-68ff337aceb5,.uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67,.uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088{stroke-width:0}.uuid-66d1e3de-ea26-4b90-aca4-6733c42c8b1a{stroke-width:8.63px}.uuid-c0fc4a04-49b4-41b6-9274-b2a3abceeadf{stroke:#40251d}.uuid-91dc50e0-ae24-409e-81f3-9b32b5558ae9,.uuid-dd96de9e-052f-408c-b767-af3056f5d898{stroke-width:4px}.uuid-91dc50e0-ae24-409e-81f3-9b32b5558ae9{stroke:#e00}.uuid-96593b59-46bf-4b64-bafb-a0122c6e07a4{stroke:#e0e0e0;fill:#fff}.uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67{fill:#fff}.uuid-4617f224-e900-44d3-8a42-c09527ea44f0{fill:#f56e6e}.uuid-9e23771d-c576-4522-a585-490ce74a0064{fill:#724335}.uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5{fill:#a3a3a3}.uuid-a3281ad5-a5c9-4204-a2f1-c4e6a296561a{fill:#dede55}.uuid-232b251e-1b1e-4d37-a9c6-9d684d739f11{fill:#c7c7c7}.uuid-5b157734-be81-4971-ae0a-27c9963600e9{fill:#e0e0e0}.uuid-bd97af27-f0f6-4711-9267-68ff337aceb5{fill:#a60000}.uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a{fill:#a0a}.uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1{fill:#e00}'
        }
      </style>
      <clipPath id="uuid-4a098f3f-5d46-4d60-a6c2-8f6ed34c5068">
        <path
          className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
          d="M164.4 727.46H214V897H164.4z"
        />
      </clipPath>
      <clipPath id="uuid-e631141e-b8a5-47fe-9308-9e8a8aeac110">
        <path
          className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
          d="M320.71 537.86s-42.56 8.91-42.56 48.93 10.2 35.18 0 83.29c-10.2 48.12-20.5 78.2 35.88 109.92s137.94 19.94 162.05-1.21c24.11-21.15-113.96-237.76-155.38-240.93z"
        />
      </clipPath>
      <clipPath id="uuid-380626cc-cbd4-46b2-aeaf-dd0f5b8f5471">
        <path
          className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
          d="M164.4 727.46H214V897H164.4z"
        />
      </clipPath>
      <clipPath id="uuid-7ca27e8b-47cd-46bd-b1c2-c67c37b81510">
        <path
          className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
          d="M946.16 692.49L946.16 719.84 922.48 733.51 898.8 719.84 898.8 692.49 922.48 678.82 946.16 692.49z"
        />
      </clipPath>
      <clipPath id="uuid-a4b12684-c18c-479b-80e3-188d2fb326aa">
        <path
          className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
          d="M903.82 678.89L903.82 715.3 872.29 733.51 840.76 715.3 840.76 678.89 872.29 660.68 903.82 678.89z"
        />
      </clipPath>
      <clipPath id="uuid-8308c15c-a6b4-4141-81be-4b914ff175bd">
        <path
          className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
          d="M855.3 252.38L855.3 288.79 823.76 306.99 792.23 288.79 792.23 252.38 823.76 234.17 855.3 252.38z"
        />
      </clipPath>
      <clipPath id="uuid-b89dd06c-ae5e-4f2e-bdde-d1b35cca3259">
        <path
          className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
          d="M342.96 504.49s-42.56 8.91-42.56 48.93c0 40.03 10.2 35.18 0 83.29-10.2 48.12-20.5 78.2 35.88 109.92s137.94 19.94 162.05-1.21c24.11-21.15-113.96-237.76-155.38-240.93z"
        />
      </clipPath>
      <clipPath id="uuid-320d38ba-2d77-4b48-b2a0-32fe6beda5c0">
        <path
          className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
          d="M161.27 345.5L161.27 372.84 137.59 386.51 113.91 372.84 113.91 345.5 137.59 331.83 161.27 345.5z"
        />
      </clipPath>
      <clipPath id="uuid-f5f27670-d813-4644-8a05-2e031f7f1426">
        <path
          className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
          d="M197.53 382.69L197.53 419.1 166 437.31 134.47 419.1 134.47 382.69 166 364.48 197.53 382.69z"
        />
      </clipPath>
    </defs>
    <g id="uuid-26e59ade-e42f-4c24-aaa1-590f6251641e" data-name="Gray-20">
      <path
        className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
        d="M50.41 561.23c10.26 52.64 33.7 101.78 67.71 138.07 73.09 78 184.43 109.16 276.36 160.41 81.51 45.44 164.24 91.65 264.8 78.52 83.54-10.91 178.11-52.8 225.63-128.11 54.83-86.9 35.27-179.25 12.61-266.98-23.37-90.47 24.74-171.28 28.12-262.05 3.24-87.02-44.35-168.36-124.15-200.15-82.73-32.96-174.35-12.17-252.48 35.24-38.68 23.47-74.73 51.53-114.69 72.77-40.42 21.5-83.26 31.64-126.55 43.78-85.41 23.95-187.81 54.47-232.95 140.14-30.08 57.1-36.73 125.24-24.43 188.35z"
      />
      <path
        className="uuid-91dc50e0-ae24-409e-81f3-9b32b5558ae9"
        d="M476.57 141.3c29.82-4.39 60.63-5.33 91.96-2.44 85.05 7.84 161.1 42.7 220.46 95.32"
      />
      <ellipse
        className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
        cx={213.54}
        cy={901.87}
        rx={173.54}
        ry={15.29}
      />
      <path
        className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
        d="M104.62 727.46H157.83V896.08H104.62z"
      />
      <path
        className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
        d="M120.07 727.53H274.87V773.23H120.07z"
      />
      <path
        className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
        d="M145.03 744.62H228.26999999999998V752.54H145.03z"
      />
      <circle
        className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
        cx={249.77}
        cy={748.58}
        r={5.5}
      />
      <path
        className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
        d="M120.07 769.8H274.87V811.89H120.07z"
      />
      <circle
        className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
        cx={249.77}
        cy={790.85}
        r={4.95}
      />
      <path
        className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
        d="M120.07 811.89H274.87V853.98H120.07z"
      />
      <circle
        className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
        cx={249.77}
        cy={832.94}
        r={5.5}
      />
      <path
        className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
        d="M120.07 853.99H274.87V896.08H120.07z"
      />
      <circle
        className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
        cx={249.77}
        cy={875.04}
        r={5.5}
      />
      <path
        className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
        d="M144.51 786.84H228.79V794.86H144.51z"
      />
      <path
        className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
        d="M145.03 828.98H228.26999999999998V836.9H145.03z"
      />
      <path
        className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
        d="M145.03 871.08H228.26999999999998V879H145.03z"
      />
      <path
        className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
        d="M275.33 770.21L120.53 770.21"
      />
      <path
        className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
        d="M275.33 811.94L120.53 811.94"
      />
      <path
        className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
        d="M275.33 853.66L120.53 853.66"
      />
      <g>
        <g clipPath="url(#uuid-4a098f3f-5d46-4d60-a6c2-8f6ed34c5068)">
          <path
            className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
            d="M120.07 727.53H274.87V773.23H120.07z"
          />
          <path
            className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
            d="M145.03 744.62H228.26999999999998V752.54H145.03z"
          />
          <circle
            className="uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a"
            cx={249.77}
            cy={748.58}
            r={5.5}
          />
          <path
            className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
            d="M120.07 769.8H274.87V811.89H120.07z"
          />
          <circle
            className="uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a"
            cx={249.77}
            cy={790.85}
            r={4.95}
          />
          <path
            className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
            d="M120.07 811.89H274.87V853.98H120.07z"
          />
          <circle
            className="uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a"
            cx={249.77}
            cy={832.94}
            r={5.5}
          />
          <path
            className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
            d="M120.07 853.99H274.87V896.08H120.07z"
          />
          <circle
            className="uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a"
            cx={249.77}
            cy={875.04}
            r={5.5}
          />
          <path
            className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
            d="M144.51 786.84H228.79V794.86H144.51z"
          />
          <path
            className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
            d="M145.03 828.98H228.26999999999998V836.9H145.03z"
          />
          <path
            className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
            d="M145.03 871.08H228.26999999999998V879H145.03z"
          />
          <path
            className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
            d="M275.33 770.21L120.53 770.21"
          />
          <path
            className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
            d="M275.33 811.94L120.53 811.94"
          />
          <path
            className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
            d="M275.33 853.66L120.53 853.66"
          />
        </g>
        <path
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          d="M183.98 613.12H237.19V907.95H183.98z"
        />
        <path
          className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
          d="M197.93 613.12H352.73V655.21H197.93z"
        />
        <circle
          className="uuid-a3281ad5-a5c9-4204-a2f1-c4e6a296561a"
          cx={327.64}
          cy={634.17}
          r={4.95}
        />
        <path
          className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
          d="M197.93 655.21H352.73V697.3000000000001H197.93z"
        />
        <circle
          className="uuid-a3281ad5-a5c9-4204-a2f1-c4e6a296561a"
          cx={327.64}
          cy={676.26}
          r={5.5}
        />
        <path
          className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
          d="M197.93 697.31H352.73V739.4H197.93z"
        />
        <circle
          className="uuid-a3281ad5-a5c9-4204-a2f1-c4e6a296561a"
          cx={327.64}
          cy={718.36}
          r={5.5}
        />
        <path
          className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
          d="M197.93 739.4H352.73V781.49H197.93z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M222.37 630.16H306.65V638.18H222.37z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M222.89 672.3H306.13V680.2199999999999H222.89z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M222.89 714.4H306.13V722.3199999999999H222.89z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M222.89 756.49H306.13V764.41H222.89z"
        />
        <circle
          className="uuid-a3281ad5-a5c9-4204-a2f1-c4e6a296561a"
          cx={327.64}
          cy={760.45}
          r={5.5}
        />
        <path
          className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
          d="M197.93 778.07H352.73V823.76H197.93z"
        />
        <circle
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          cx={327.64}
          cy={802.72}
          r={4.95}
        />
        <path
          className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
          d="M197.93 823.76H352.73V865.85H197.93z"
        />
        <circle
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          cx={327.64}
          cy={844.81}
          r={5.5}
        />
        <path
          className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
          d="M197.93 865.86H352.73V907.95H197.93z"
        />
        <circle
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          cx={327.64}
          cy={886.91}
          r={5.5}
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M222.37 798.71H306.65V806.73H222.37z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M222.89 840.85H306.13V848.77H222.89z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M222.89 882.95H306.13V890.87H222.89z"
        />
      </g>
      <g clipPath="url(#uuid-e631141e-b8a5-47fe-9308-9e8a8aeac110)">
        <g clipPath="url(#uuid-380626cc-cbd4-46b2-aeaf-dd0f5b8f5471)">
          <path
            className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
            d="M120.07 727.53H274.87V773.23H120.07z"
          />
          <path
            className="uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a"
            d="M145.03 744.62H228.26999999999998V752.54H145.03z"
          />
          <circle
            className="uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a"
            cx={249.77}
            cy={748.58}
            r={5.5}
          />
          <path
            className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
            d="M120.07 769.8H274.87V811.89H120.07z"
          />
          <circle
            className="uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a"
            cx={249.77}
            cy={790.85}
            r={4.95}
          />
          <path
            className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
            d="M120.07 811.89H274.87V853.98H120.07z"
          />
          <circle
            className="uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a"
            cx={249.77}
            cy={832.94}
            r={5.5}
          />
          <path
            className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
            d="M120.07 853.99H274.87V896.08H120.07z"
          />
          <circle
            className="uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a"
            cx={249.77}
            cy={875.04}
            r={5.5}
          />
          <path
            className="uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a"
            d="M144.51 786.84H228.79V794.86H144.51z"
          />
          <path
            className="uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a"
            d="M145.03 828.98H228.26999999999998V836.9H145.03z"
          />
          <path
            className="uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a"
            d="M145.03 871.08H228.26999999999998V879H145.03z"
          />
          <path
            className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
            d="M275.33 770.21L120.53 770.21"
          />
          <path
            className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
            d="M275.33 811.94L120.53 811.94"
          />
          <path
            className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
            d="M275.33 853.66L120.53 853.66"
          />
        </g>
        <path
          className="uuid-28a8f6d4-c265-4c4e-bfb9-e688eb77f20a"
          d="M183.98 613.61H237.19V907.83H183.98z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M197.93 613.12H352.73V655.21H197.93z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M197.93 655.21H352.73V697.3000000000001H197.93z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M197.93 697.31H352.73V739.4H197.93z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M197.93 739.4H352.73V781.49H197.93z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M197.93 778.07H352.73V823.76H197.93z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M197.93 823.76H352.73V865.85H197.93z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M197.93 865.86H352.73V907.95H197.93z"
        />
        <circle
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          cx={327.64}
          cy={634.17}
          r={4.95}
        />
        <circle
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          cx={327.64}
          cy={676.26}
          r={5.5}
        />
        <circle
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          cx={327.64}
          cy={718.36}
          r={5.5}
        />
        <path
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          d="M222.37 630.16H306.65V638.18H222.37z"
        />
        <path
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          d="M222.89 672.3H306.13V680.2199999999999H222.89z"
        />
        <path
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          d="M222.89 714.4H306.13V722.3199999999999H222.89z"
        />
        <path
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          d="M222.89 756.49H306.13V764.41H222.89z"
        />
        <circle
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          cx={327.64}
          cy={760.45}
          r={5.5}
        />
        <circle
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          cx={327.64}
          cy={802.72}
          r={4.95}
        />
        <circle
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          cx={327.64}
          cy={844.81}
          r={5.5}
        />
        <circle
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          cx={327.64}
          cy={886.91}
          r={5.5}
        />
        <path
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          d="M222.37 798.71H306.65V806.73H222.37z"
        />
        <path
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          d="M222.89 840.85H306.13V848.77H222.89z"
        />
        <path
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          d="M222.89 882.95H306.13V890.87H222.89z"
        />
      </g>
      <path
        className="uuid-96593b59-46bf-4b64-bafb-a0122c6e07a4"
        d="M1004.44 502.74c-6.21-46.64-46.12-82.63-94.46-82.63-52.65 0-95.33 42.68-95.33 95.33v.38c-1.29-.11-2.6-.17-3.92-.17-26.27 0-47.56 21.29-47.56 47.56s21.29 47.56 47.56 47.56c.67 0 1.34-.02 2.01-.05v.05H978.45c1.21.08 2.42.13 3.65.13 31.14 0 56.38-25.24 56.38-56.38 0-23.21-14.03-43.13-34.06-51.78z"
      />
      <path
        className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
        d="M929.99 510.06c0-11.34-9.19-20.54-20.54-20.54s-20.54 9.19-20.54 20.54c0 7.99 4.58 14.91 11.25 18.3v20.33c0 5.11 4.18 9.29 9.29 9.29s9.29-4.18 9.29-9.29v-20.33c6.67-3.39 11.25-10.3 11.25-18.3z"
      />
      <path
        className="uuid-96593b59-46bf-4b64-bafb-a0122c6e07a4"
        d="M642.47 396.04c0-35.59-28.85-64.45-64.45-64.45-.78 0-1.56.03-2.34.06-7.65-47.72-48-84.5-97.34-86.65-20.19-70.73-85.31-122.51-162.52-122.51-87.82 0-159.99 67-168.21 152.67-.28 0-.56-.02-.84-.02-51.18 0-92.68 41.49-92.68 92.68s41.22 92.39 92.17 92.66.5.01.5.01h432.31v-.03c35.09-.58 63.37-29.19 63.37-64.42z"
      />
      <g>
        <path
          className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
          d="M692.25 237.03a328.054 328.054 0 0150.75 35.3"
        />
        <path
          className="uuid-dd96de9e-052f-408c-b767-af3056f5d898"
          d="M883.61 739.9a415.837 415.837 0 01-57.99 73.28M532.2 108.11c106.39 0 203.4 40.17 276.69 106.17"
        />
        <path
          className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
          d="M911.55 745.14a441.744 441.744 0 01-41.49 58.75"
        />
        <path
          className="uuid-dd96de9e-052f-408c-b767-af3056f5d898"
          d="M828.17 720.93c-5.3 7.85-10.9 15.49-16.79 22.88M617.86 175.3c52.63 12.97 100.65 37.62 141.18 71.04"
        />
      </g>
      <g>
        <g clipPath="url(#uuid-7ca27e8b-47cd-46bd-b1c2-c67c37b81510)">
          <path
            className="uuid-4617f224-e900-44d3-8a42-c09527ea44f0"
            d="M946.06 692.44L922.48 678.82 898.9 692.44 922.5 706.06 946.06 692.44z"
          />
          <path
            className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
            d="M898.8 692.61L898.8 719.84 922.4 733.46 922.4 706.23 898.8 692.61z"
          />
          <path
            className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
            d="M922.6 733.44L946.16 719.84 946.16 692.61 922.6 706.23 922.6 733.44z"
          />
          <path
            className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
            d="M922.43 706.11s.01 0 .02-.01c0 0-.01 0-.02.01zM922.41 706.14v-.02.02z"
          />
          <g>
            <path
              className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
              d="M898.8 692.49L922.5 706.18"
            />
            <path
              className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
              d="M946.16 692.49L922.5 706.18"
            />
          </g>
        </g>
        <g clipPath="url(#uuid-a4b12684-c18c-479b-80e3-188d2fb326aa)">
          <path
            className="uuid-4617f224-e900-44d3-8a42-c09527ea44f0"
            d="M903.69 678.81L872.29 660.68 840.89 678.81 872.32 696.96 903.69 678.81z"
          />
          <path
            className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
            d="M840.76 679.04L840.76 715.3 872.18 733.44 872.18 697.19 840.76 679.04z"
          />
          <path
            className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
            d="M872.45 733.41L903.82 715.3 903.82 679.04 872.45 697.19 872.45 733.41z"
          />
          <path
            className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
            d="M872.22 697.02l.02-.02s-.02.01-.02.02zM872.19 697.07s0-.02.01-.02c0 0 0 .01-.01.02z"
          />
          <g>
            <path
              className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
              d="M840.76 678.89L872.32 697.11"
            />
            <path
              className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
              d="M903.82 678.89L872.32 697.11"
            />
          </g>
        </g>
        <g clipPath="url(#uuid-8308c15c-a6b4-4141-81be-4b914ff175bd)">
          <path
            className="uuid-4617f224-e900-44d3-8a42-c09527ea44f0"
            d="M855.16 252.3L823.76 234.17 792.36 252.3 823.79 270.44 855.16 252.3z"
          />
          <path
            className="uuid-4617f224-e900-44d3-8a42-c09527ea44f0"
            d="M792.23 252.53L792.23 288.79 823.65 306.93 823.65 270.68 792.23 252.53z"
          />
          <path
            className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
            d="M823.92 306.9L855.3 288.79 855.3 252.53 823.92 270.68 823.92 306.9z"
          />
          <path
            className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
            d="M823.69 270.51l.02-.02s-.02.01-.02.02zM823.66 270.56s0-.02.01-.02c0 0 0 .01-.01.02z"
          />
          <g>
            <path
              className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
              d="M792.23 252.38L823.79 270.6"
            />
            <path
              className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
              d="M823.79 270.6L823.79 309.48"
            />
            <path
              className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
              d="M855.3 252.38L823.79 270.6"
            />
          </g>
        </g>
        <g>
          <path
            className="uuid-4617f224-e900-44d3-8a42-c09527ea44f0"
            d="M802 271.97L778.42 258.36 754.84 271.97 778.44 285.6 802 271.97z"
          />
          <path
            className="uuid-4617f224-e900-44d3-8a42-c09527ea44f0"
            d="M754.74 272.14L754.74 299.37 778.34 312.99 778.34 285.77 754.74 272.14z"
          />
          <path
            className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
            d="M778.54 312.97L802.1 299.37 802.1 272.14 778.54 285.77 778.54 312.97z"
          />
          <path
            className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
            d="M778.36 285.65s.01 0 .02-.01c0 0-.01 0-.02.01zM778.34 285.68v-.02.02z"
          />
          <g>
            <path
              className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
              d="M754.74 272.03L778.44 285.71"
            />
            <path
              className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
              d="M802.1 272.03L778.44 285.71"
            />
          </g>
        </g>
      </g>
      <g>
        <path
          className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
          d="M442.71 776.86s-8.46 3.63-25.4 3.63-27.81-3.63-27.81-3.63v-31.44h53.21v31.44z"
        />
        <path
          className="uuid-5b157734-be81-4971-ae0a-27c9963600e9"
          d="M701.65 982.39c0-12.01-101.48-21.75-254.11-21.75s-276.35 9.74-276.35 21.75c0 8.94 68.55 16.62 166.53 19.96 8.1.28 16.17 1.48 23.93 3.83 17.34 5.26 56.19 8.92 101.34 8.92s85.98-3.85 102.63-9.32c8.07-2.65 16.42-4.37 24.9-4.78 79.95-3.81 111.13-10.72 111.13-18.62z"
        />
        <path
          className="uuid-66d1e3de-ea26-4b90-aca4-6733c42c8b1a"
          d="M417.25 755.46v146.07s-2.59 48.34 83.41 70.33M338.42 971.85s78.82-22.44 78.83-70.33"
        />
        <path
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          d="M746.85 633.19H433.66a2.5 2.5 0 010-5h313.19a2.5 2.5 0 010 5z"
        />
        <path
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          d="M342.96 504.49s-42.56 8.91-42.56 48.93c0 40.03 10.2 35.18 0 83.29-10.2 48.12-20.5 78.2 35.88 109.92s137.94 19.94 162.05-1.21c24.11-21.15-113.96-237.76-155.38-240.93z"
        />
        <g clipPath="url(#uuid-b89dd06c-ae5e-4f2e-bdde-d1b35cca3259)">
          <path
            className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
            d="M359.26 501.14c-16.93-2.42-39.91 18.14-37.49 44.75 2.42 26.61 12.09 48.37 2.42 90.7-8.59 37.57-8.23 81.66 24.91 91.02s82.96-3.62 85.26 38.54c0 0 32.53 25.23 57.93 8.3s31.44-65.3 1.21-85.86c-30.23-20.56-134.24-187.45-134.24-187.45z"
          />
        </g>
        <path
          className="uuid-232b251e-1b1e-4d37-a9c6-9d684d739f11"
          d="M402.4 472.5s-1.18 4.18-36.56 14.97c-15.32 4.67-28.3 13.29-29.35 39.84-1.05 26.54-.35 88.03 41.57 107.95 30.15 14.32 61.71.14 92.02-8.77l26.85 26.96s-5.18-32.16-4.02-32.35c4.92-.82 8.48-1.05 13.02-.87l.49-29.42-15.97.74-1.03-12.48 21.06 13.56s33.89-1.75 37.03-1.75 5.94.7 6.99 2.1c0 0 5.94-3.14 10.83 1.75 0 0 4.54-2.45 11.18 3.84l15.37 12.93 6.99-16.42-39.48-17.12s-35.29-33.44-45.77-46.07c-10.48-12.63-36.64-37.78-52.03-42.67-15.39-4.89-59.19-16.72-59.19-16.72z"
        />
        <path
          className="uuid-9e23771d-c576-4522-a585-490ce74a0064"
          d="M482 389.81s4.64 17.57 3.82 27.06c-.34 3.86-6.05 9.5-5.14 16.83.24 1.96 5.01 5.53 4.15 9.21-.67 2.85-4.33 1.41-5.67 2.37 0 0-.88 2.31-.1 7.96.12.84-.3 1-.98 2.14l-1.22 2.13.88 1.98c.15.34.12.72-.06 1.05-2.17 4.06-1.76 11.13-2.4 13.49-1.88 7-4.59 7.41-17.65 6.44 0 0-3.17 8.29-4.3 15.07l11.84 9.96s-17.74 25.17-22.08 35.18c-5.22-5.69-25.78-32.29-30.61-33.5-4.84-1.21-8.15-22.95-8.15-22.95l-1.92-11.74s14.03-12.22 4.88-31.88c-9.15-19.65-11.21-42.14 1.32-58.07 12.92-16.42 54.01-33.13 73.4 7.25z"
        />
        <path
          className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
          d="M423.17 420.76s1.62-6.26 3.03-7.88c1.41-1.62.81-4.26 1.01-5.25.81-4.04 4.71-2.96 7.94-5.65 3.23-2.69 1.62-8.35 5.92-9.15 4.31-.81 6.87-2.56 8.35-4.04 1.48-1.48 2.96-2.02 6.46-.94s6.73-4.85 10.63-1.35 8.21 1.88 10.9 2.56c2.69.67 4.5 6.24 6.82 4.87s11.52-10.94 7.03-14.44c-4.49-3.5-1.28-5.79-4.65-9.02-3.37-3.23-3.42-7.53-7.19-9.14-3.77-1.62-6.06.4-8.48 0s-3.5-4.98-7.13-5.65c-3.63-.67-5.65 1.88-9.15 1.62-3.5-.27-2.83-2.96-6.87-3.1-4.04-.13-2.83 2.69-7.13 2.69s-5.25-1.35-8.75.67-4.58 3.1-6.33 3.37-4.44-.67-7.27.81c-2.83 1.48-2.56 5.92-5.65 7.13-3.1 1.21-7.4 2.15-9.69 4.71s0 6.46-3.17 8.62-4.91 3.63-6.26 8.48c-1.35 4.85.81 6.06 0 10.63-.81 4.58-1.62 5.92.94 11.44s4.17 11.31 6.06 16.83c1.88 5.52 9.2 16.11 9.33 20.71l3.46-11.56s-11.45-9.57-6.46-22.35c4.31-11.04 14.54-3.5 16.29 4.38z"
        />
        <path
          className="uuid-c0fc4a04-49b4-41b6-9274-b2a3abceeadf"
          d="M468.33 443.72s-1.7-.35-2.38-1.02"
        />
        <path
          className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
          d="M471.69 409.98c1.66.92 1.05 3.37-.87 3.31-.28 0-.68-.14-.95-.23-7.83-2.63-17.04-3.24-24.23 1.47-.32.21-.76.12-.97-.2-.2-.31-.13-.72.16-.94 1.85-1.4 3.93-2.52 6.13-3.31 2.2-.79 4.51-1.26 6.84-1.46 4.48-.4 8.99.2 13.34 1.28.11.01-.11-.02-.14-.02-1.29-.1-2.26 1.49-1.5 2.6.11.2.31.36.41.45-2.06-1.2-.23-4.21 1.78-2.94z"
        />
        <path
          d="M444.33 417.18s-.12 12.56 3.85 18.28c10.37 2.98 20.99.97 20.92 1.1 4.64-10.18 3.74-19.46 3.74-19.46-8.6-3.36-28.51-.82-28.51-.82l-22.35-.08"
          strokeLinejoin="round"
          strokeWidth="2.16px"
          stroke="#000"
          strokeLinecap="round"
          fill="none"
        />
        <path
          className="uuid-c8385442-ac2c-47fb-855e-85c4f2d77532"
          d="M480.29 418s7.78-1.35 13.03.8c0 0 .52 8.48-4.05 16.71 0 0-3.97 1.83-7.01.91"
        />
        <path
          className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
          d="M482.12 413.38c2.04-.46 4.24-.4 5.99.84.66.48.07 1.52-.68 1.23-1.05-.31-2.18-.08-3.18.35-.32.14-.71.33-.92.49-.71.55-1.73.41-2.27-.3-.77-.96-.13-2.44 1.06-2.61z"
        />
        <path
          className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
          d="M402.4 471.29s.29 11.84 7.65 23.8c9.67 15.72 33.86 45.95 33.86 45.95l-1.21 1.21s-14.84-21.19-24.19-26.61c-15.35-8.89-29-7.15-29-7.15l7.23-33.96 5.65-3.24z"
        />
        <path
          className="uuid-232b251e-1b1e-4d37-a9c6-9d684d739f11"
          d="M341.57 585.32s-.8 56.45-3.15 71.3c-2.34 14.85-7.82 35.67-7.82 35.67l50.13-57.06s-27.04-6.14-39.16-49.91z"
        />
        <path
          className="uuid-9e23771d-c576-4522-a585-490ce74a0064"
          d="M505.94 592.28s37.51-1.86 41.57-1.4c4.06.47 6.99 2.1 6.99 2.1s5.95-2.15 10.83 1.75c0 0 5.22-1.17 11.18 3.84s15.37 12.93 15.37 12.93l-3.02 6.31-11.19-6.13 5.33 9.33h-28.78s-21.05-8.26-30.64-8.79c-9.59-.53-17.64 1.6-17.64 1.6v-21.53z"
        />
        <path
          className="uuid-c0fc4a04-49b4-41b6-9274-b2a3abceeadf"
          d="M531.07 598.69s7.88-1.48 14.54 5.17c6.65 6.65 19.56 17.14 19.56 17.14M539.94 592.78s7.72-.18 13.91 7.84 16.63 20.4 16.63 20.4"
        />
        <path
          className="uuid-c0fc4a04-49b4-41b6-9274-b2a3abceeadf"
          d="M530.38 591.23l10.56-.33c1.24-.04 2.47-.1 3.7-.23 2.14-.24 7.83-.21 13.09 5.59 6.64 7.33 19.7 21.53 19.7 21.53s-4.66 6.08-10.69-1.24"
        />
        <path
          className="uuid-c0fc4a04-49b4-41b6-9274-b2a3abceeadf"
          d="M554.5 592.98s9.65-2.22 13.77 5.57c4.12 7.79 14.72 22.46 14.72 22.46"
        />
        <path
          className="uuid-c0fc4a04-49b4-41b6-9274-b2a3abceeadf"
          d="M565.33 594.73s4.42-2.17 8.9 1.76c4.48 3.93 17.65 15.01 17.65 15.01"
        />
        <path
          className="uuid-bd97af27-f0f6-4711-9267-68ff337aceb5"
          d="M568.86 735.7l-12.55-13.99-25.56 30.14c4.74 3.63 13.89 12.98 17.01 16.27 10.6-7.25 15.47-20.96 21.1-32.42z"
        />
        <path
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          d="M617.83 776.2c-19.34-6.58-29.63-18.93-29.63-18.93l-19.34-21.57c-5.63 11.46-13.24 22.42-23.84 29.67 5.66 5.96 6.15 7.62 6.15 7.62s.41 26.66 7.82 32.01c7.41 5.35 22.22 8.64 32.9 7.82 10.68-.82 30.06 9.88 40.76 11.11 10.7 1.23 39.51 0 41.16-18.11 1.65-18.11-36.63-23.05-55.97-29.63z"
        />
        <path
          className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
          d="M542.27 762.64s17.36-10.05 26.48-27.05L583 751.48s-5.18-5.03-5.56 7.98c-.39 13.02-7.35 15.87-12.28 15.87s-8.28-4.18-14-2.33c0 0-3.52-4.99-8.89-10.36zM553.79 794.84s14.31 9.23 30.92 7.84c16.61-1.38 22.15 2.25 27.69 5.45 5.54 3.2 38.38 18.16 61.41-2.3 0 0-1.89 17.56-29.23 18.45-27.34.89-33.43-10.74-48.82-11.33-15.39-.59-25.82-1.12-36.77-7.95 0 0-3.68-2.27-5.19-10.17z"
        />
        <path
          className="uuid-dd96de9e-052f-408c-b767-af3056f5d898"
          d="M606.48 771.26L600.49 781.79"
        />
        <path
          className="uuid-dd96de9e-052f-408c-b767-af3056f5d898"
          d="M619.78 776.53L613.8 787.06"
        />
        <path
          className="uuid-bd97af27-f0f6-4711-9267-68ff337aceb5"
          d="M509.44 913.29c1.98-10.48 4.34-20.07 4.34-20.07l-45.2-7.82s-2.3 8.68-2.03 24.69c10.84 17.93 11.76 14.28 42.89 3.19z"
        />
        <path
          className="uuid-7cc7312e-4c40-4551-a473-fdb2b861bfd5"
          d="M546.95 967.92c-22.69-4.89-38.34-20.86-39.97-30.64-.38-2.3-.21-5.97.28-10.22.49-4.25-40.86-3.77-41.61 2.11-1.12 8.8-3.27 16.85-6.59 24.08-5.54 12.06-8.15 18.26-4.89 28.04 0 0 12.71 8.15 30.64 7.17 17.93-.98 18.91 5.22 40.75 8.8 21.84 3.59 36.19 2.93 39.45-4.56 3.26-7.5 4.63-19.89-18.06-24.78z"
        />
        <path
          className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
          d="M466.53 909.36s22.75 9.53 43.26 3.1c0 0-2.82 14.73-2.81 24.82 0 0-7.23-5.75-12.33 5.87-2.04 4.64-7.02 7.58-17.77.4-5.1-3.4-11.4-1.46-13.76-1.51 0 0 3.35-24.33 3.42-32.68zM453.11 969.19s2.22 9.84 27.22 9.25c25-.6 28.87 5.95 41.66 9.82 12.8 3.87 38.21 7.83 44.7-1.44 0 0 3.73 22.17-50.84 8.39 0 0-15.84-7.44-31.04-6.74-15.2.69-25.85-4.62-30.64-7.17 0 0-2.06-8.13-1.06-12.1z"
        />
        <path
          className="uuid-dd96de9e-052f-408c-b767-af3056f5d898"
          d="M521.29 955.72L512.59 964.14"
        />
        <path
          className="uuid-dd96de9e-052f-408c-b767-af3056f5d898"
          d="M534.48 962.71L525.77 971.14"
        />
        <path
          className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
          d="M478.23 721.71s10.11 12.33-1.1 60.85c-11.22 48.52-26.33 79.26-26.01 105.79 0 0 8.25 7.42 29.02 12.27 27.41 6.4 41.12-.91 41.4-.21 0 0 3.93-42.42 11.22-68.83 7.29-26.41 10.56-68.25 10.56-68.25s-8.33-11.7-12.58-11.46c-1.69.09-13.56 15.5-13.56 15.5l-38.96-45.64z"
        />
        <path
          className="uuid-a5d948ef-0976-4021-8af2-c95112228428"
          d="M381.14 597.88s55.63 1.21 109.31-5.12M381.44 538.85c-.29-.22 8.42 58.78 8.42 58.78"
        />
        <path
          className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
          d="M485.28 534s7.24 26.13 16.92 38.15c15.04 18.66 28.54 19.04 28.54 19.04l-20.24.91-4.56.18v-2.57l-16.52-10.63s-4.57-31.71-4.15-45.08zM543.32 735.59s-8.24 25.36 26.96 38.26c-4.45 31.03 11.14 38.26 11.14 38.26s-15.8-1.53-22.45-7.1c-8.7-7.29-7.82-32.01-7.82-32.01s-11.71-15.59-20.42-21.15l12.58-16.27z"
        />
        <path
          className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
          d="M500.66 620.16L505.94 629.48 692.51 629.48 735.66 527.81 624.6 527.81 586.9 621.01 500.66 620.16z"
        />
        <path
          className="uuid-c0fc4a04-49b4-41b6-9274-b2a3abceeadf"
          d="M421.42 442.1s-9.46-1.77-14.92-14.28c-5.47-12.5 8.6-25.58 16.67-7.06"
        />
        <path
          className="uuid-32b43f5e-f0d1-49a5-ab2e-288b1dca8a9e"
          d="M449.53 422.68s7.73-2.3 17.79-.38M479.59 422.3s2.32-.09 5.65.68"
        />
        <path
          className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
          d="M464.07 422.9c0 1.73-1.4 3.14-3.14 3.14s-3.14-1.4-3.14-3.14c0-.84.33-1.59.86-2.16.57-.6 4.34-.42 4.9.44.32.49.51 1.08.51 1.72zM479.59 425.32c0 1.21.69 2.25 1.7 2.77.36-1.86 1.42-3.59 2.02-5.42-3.13-.58-3.72 1.19-3.72 2.65z"
        />
        <circle
          className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
          cx={481.66}
          cy={425.35}
          r={2.85}
        />
        <path
          d="M424.72 465.08s15.71 12.32 32.91 15.39c0 0-2.11 4.98-2.69 8.75-.33 2.18-2.55 17.97-2.55 17.97s1.01-13.86-7.15-21.8c-11.96-11.64-20.52-20.3-20.52-20.3z"
          fill="#40251d"
          strokeWidth={0}
        />
        <path
          className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
          d="M406.28 725.07s57.63-6.28 75.63 9.09l-1.14-6.25-36.75-39.8-37.74 36.96z"
        />
        <path
          className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
          d="M329.55 686.06c.69-3.22 2.34-6.15 4.71-8.43 7.55-7.23 27.1-25.95 51.79-49.69 31.86-30.64 45.46-40.75 57.97-28.49 12.5 12.26 74.63 81.41 121.14 111.93 0 0 .35 8.99-13.55 26.47-13.9 17.48-34.42 29.5-34.42 29.5l-73.16-79.24-37.74 36.96s-31.52 1.42-43.51 3.68c-15.81 2.98-40.15-10.35-33.22-42.68zM482.04 418.58c-1.38 3.9-1.66 8.13-1.42 12.26.04.61.2 1.17-.49 1.94-.94-.45-.97-1.11-1.1-1.73-.12-.62-.23-1.25-.32-1.88-.5-3.83-.33-7.88 1.33-11.44.6-1.24 2.46-.43 1.98.85z"
        />
        <path
          className="uuid-c0fc4a04-49b4-41b6-9274-b2a3abceeadf"
          d="M477.96 419.6s-2.12 5.53 3.16 14.75c3.6 6.27 5.79 10.2-.47 10.85-6.97.72-9.96-.81-9.96-.81M476.85 457.51s-5.24.97-13.85-2.53"
        />
        <path
          className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
          d="M456.64 483.02s7.13 8.23 10.68 12.66 11.67 12.72 11.67 12.72-10.67.79-21.96 11.54c-11.05 10.53-13.11 22.33-13.11 22.33h-1.21s9.05-34.89 10.12-45.57c.73-7.34 3.82-13.66 3.82-13.66z"
        />
        <path
          className="uuid-b4b293bf-3d6c-4719-bad2-00f7949283d0"
          d="M341.57 585.32s4.43 23.88 19.18 36.64c14.74 12.76 18.54 13.29 18.54 13.29l-19.46 17.71s-15.52-4.45-20.42-49.17c-.61-5.52 2.52-11.66 2.17-18.47z"
        />
        <path
          className="uuid-c8385442-ac2c-47fb-855e-85c4f2d77532"
          d="M472.84 420.75s2.6-2.56 7.45 0"
        />
      </g>
      <g clipPath="url(#uuid-320d38ba-2d77-4b48-b2a0-32fe6beda5c0)">
        <path
          className="uuid-4617f224-e900-44d3-8a42-c09527ea44f0"
          d="M161.17 345.44L137.59 331.83 114.01 345.44 137.61 359.07 161.17 345.44z"
        />
        <path
          className="uuid-4617f224-e900-44d3-8a42-c09527ea44f0"
          d="M113.91 345.62L113.91 372.84 137.51 386.47 137.51 359.24 113.91 345.62z"
        />
        <path
          className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
          d="M137.71 386.44L161.27 372.84 161.27 345.62 137.71 359.24 137.71 386.44z"
        />
        <path
          className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
          d="M137.53 359.12s.01 0 .02-.01c0 0-.01 0-.02.01zM137.51 359.15v-.02.02z"
        />
        <g>
          <path
            className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
            d="M113.91 345.5L137.61 359.18"
          />
          <path
            className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
            d="M137.61 359.18L137.61 388.38"
          />
          <path
            className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
            d="M161.27 345.5L137.61 359.18"
          />
        </g>
      </g>
      <path
        className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
        d="M93.15 489.6a438.71 438.71 0 0119.99-103.09"
      />
      <g>
        <path
          className="uuid-91dc50e0-ae24-409e-81f3-9b32b5558ae9"
          d="M155.4 603.79c-7.91-37.15-10.42-76.11-6.75-115.92 1.23-13.4 3.14-26.58 5.68-39.5"
        />
        <path
          className="uuid-dd96de9e-052f-408c-b767-af3056f5d898"
          d="M121.15 567.83a418.415 418.415 0 01-2.54-46.13c0-33.19 3.91-65.46 11.29-96.38M177.25 485.54c1.65-16.36 4.4-32.4 8.18-48.03"
        />
      </g>
      <g clipPath="url(#uuid-f5f27670-d813-4644-8a05-2e031f7f1426)">
        <path
          className="uuid-4617f224-e900-44d3-8a42-c09527ea44f0"
          d="M197.4 382.61L166 364.48 134.6 382.61 166.03 400.76 197.4 382.61z"
        />
        <path
          className="uuid-4617f224-e900-44d3-8a42-c09527ea44f0"
          d="M134.47 382.84L134.47 419.1 165.89 437.24 165.89 400.99 134.47 382.84z"
        />
        <path
          className="uuid-92840446-f5e4-4ad9-a041-73e3565dd5b1"
          d="M166.16 437.21L197.53 419.1 197.53 382.84 166.16 400.99 166.16 437.21z"
        />
        <path
          className="uuid-c7ad3f39-ddcf-4db3-ab39-963e98cadc67"
          d="M165.93 400.82l.02-.02s-.02.01-.02.02zM165.9 400.87s0-.02.01-.02c0 0 0 .01-.01.02z"
        />
        <g>
          <path
            className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
            d="M134.47 382.69L166.03 400.91"
          />
          <path
            className="uuid-fb54ee19-5fdf-4ac6-ad5e-d3752baf4088"
            d="M197.53 382.69L166.03 400.91"
          />
        </g>
      </g>
      <path
        className="uuid-91dc50e0-ae24-409e-81f3-9b32b5558ae9"
        d="M852.79 739.9c-59.68 87.91-154.3 149.05-261.98 165.24"
      />
    </g>
  </svg>
);

export default AdminGuidedTourBannerDark;
